import React from 'react'

function CalendarModal({ showCalendar, onClose, onDateSelect, selectedDate }) {
  if (!showCalendar) return null

  const today = new Date()
  const currentDate = new Date(today.getFullYear(), today.getMonth(), 1)
  const months = []
  
  // Generate 6 months of calendar
  for (let i = 0; i < 6; i++) {
    const monthStart = new Date(currentDate.getFullYear(), currentDate.getMonth() + i, 1)
    const monthEnd = new Date(currentDate.getFullYear(), currentDate.getMonth() + i + 1, 0)
    const daysInMonth = monthEnd.getDate()
    const startingDayOfWeek = monthStart.getDay()
    
    months.push({
      name: monthStart.toLocaleDateString('en-US', { month: 'long', year: 'numeric' }),
      daysInMonth,
      startingDayOfWeek,
      monthStart
    })
  }

  return (
    <div className="calendar-overlay">
      <div className="calendar-modal">
        <div className="calendar-header">
          <h3>Select Date</h3>
          <button className="close-calendar" onClick={onClose}>×</button>
        </div>
        <div className="calendar-months">
          {months.map((month, monthIndex) => (
            <div key={monthIndex} className="calendar-month">
              <h4>{month.name}</h4>
              <div className="calendar-grid">
                <div className="calendar-weekdays">
                  {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
                    <div key={day} className="weekday">{day}</div>
                  ))}
                </div>
                <div className="calendar-days">
                  {Array.from({ length: month.startingDayOfWeek }, (_, i) => (
                    <div key={`empty-${i}`} className="calendar-day empty"></div>
                  ))}
                  {Array.from({ length: month.daysInMonth }, (_, i) => {
                    const date = new Date(month.monthStart.getFullYear(), month.monthStart.getMonth(), i + 1)
                    const isToday = date.toDateString() === today.toDateString()
                    const isSelected = selectedDate === date.toDateString()
                    const isPast = date < today
                    
                    return (
                      <div
                        key={i + 1}
                        className={`calendar-day ${isSelected ? 'selected' : ''} ${isToday ? 'today' : ''} ${isPast ? 'past' : ''}`}
                        onClick={() => !isPast && onDateSelect(date)}
                      >
                        {i + 1}
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default CalendarModal